import uiRouter from 'angular-ui-router';
import angularTranslate from 'angular-translate';

// import modules this module depends on
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';
import gzHpId from 'gazelle/src/components/hpid/hpid.module';
import gzEula from 'gazelle/src/components/user/eula/eula.module';

// import this modules components
import './hpid-sign-in.scss';
import * as hpIdSignInController from './hpid-sign-in.controller';

// define the module in one place and export the module name
export default angular.module('register.components.accept.hpIdSignIn', [
  'rhino.components.invitation',
  'rhino.components.locale',
  uiRouter,
  gzHpId,
  gazelleAnalytics,
  gzEula,
  angularTranslate,
])
  .controller(hpIdSignInController.name, hpIdSignInController.default)
  .name;




// WEBPACK FOOTER //
// ./components/accept/hpid-sign-in/hpid-sign-in.module.js